import { render, staticRenderFns } from "./NvConfirm.vue?vue&type=template&id=b4679540&scoped=true&"
import script from "./NvConfirm.vue?vue&type=script&lang=js&"
export * from "./NvConfirm.vue?vue&type=script&lang=js&"
import style0 from "./NvConfirm.vue?vue&type=style&index=0&id=b4679540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4679540",
  null
  
)

export default component.exports